import {useHistoryKeyInfoQueryVars} from '../../state/runs/hooks';
import {useWorkspaceRefsContext} from '../Workspace/WorkspaceRefsContext';

export function useWorkspaceHistoryKeyInfoQueryVars() {
  const {runSetRefs, customRunNamesRef} = useWorkspaceRefsContext();
  return useHistoryKeyInfoQueryVars(runSetRefs, customRunNamesRef);
}
